import '@reach/dialog/styles.css';
import 'focus-visible/dist/focus-visible.min';
import * as lazySizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
lazySizes.cfg.expFactor = 2.5;